export default {
    url: 'trade-in',
    include: ['us'],
};
